module.exports = __webpack_public_path__ + "static/img/shezhi_yongjin.1c2448cb.png";